import api from '../services/api.service';
import { API_ROUTES } from '../constants/apiRoutes';
import { extractData } from '../utils/helpers/extractDataHelper';

const getCommitsRoute = (projectId, taskId) => `/projects/${projectId}/tasks/${taskId}/commits`;

const schema = {
  getImportantTasksRequest: async () => {
    try {
      const response = await api.get(API_ROUTES.IMPORTANT_TASKS);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  getTaskCommits: async (projectId, taskId, params = {}) => {
    try {
      const response = await api.get(`${getCommitsRoute(projectId, taskId)}`, params);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  importTasks: async (projectId, sprintId, file) => {
    try {
      const response = await api.post(`/tasks/import?project_id=${projectId}&sprint_id=${sprintId}`, file);
      return extractData(response);
    } catch (error) {
      throw new Error(error.response.data.result.message ?? 'Failed to import tasks');
    }
  },
};

export default schema;
